// extracted by mini-css-extract-plugin
module.exports = {"container":"LeadBoxSkeleton_container__UMfVp","skeleton-item":"LeadBoxSkeleton_skeleton-item__F2pU0"};